/** Nexus 4xx responses carry a human-readable message (validation, decline reason); anything else gets the fallback. */
export function apiErrorMessage(error: unknown): string | undefined {
	const response = (error as { response?: { status?: number; data?: { message?: string } } } | null)?.response

	if (response?.status === undefined || response.status < 400 || response.status >= 500) {
		return undefined
	}

	return response.data?.message
}
